import React from 'react'
import ModernUserTag from './ModernUserTag'

// 기존 UserTag 인터페이스를 유지하면서 ModernUserTag을 사용
const UserTag = (props: any) => {
	return <ModernUserTag {...props} />
}

export default React.memo(UserTag)
